module.exports = __webpack_public_path__ + "media/טרקטור.71e6acde.mp3";